import { createApp } from 'vue'
// import VueRouter from "vue-router";
import router from "./router/router.js";
// import Spinner from "vue-simple-spinner";
import App from './App.vue'
import jQuery from 'jquery'
global.jquery = jQuery
global.$ = jQuery
window.$ = window.jQuery = require('jquery')

//Firebase関連
import { initializeApp } from "firebase/app";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import firebaseConfig from "./myconfig";
import { getAnalytics, logEvent } from "firebase/analytics";

// import router from "./router";
// Vue.config.productionTip = false;
//Firebase関連セッティング
const firebaseApp = initializeApp(firebaseConfig);
// export const functions = getFunctions(firebaseApp, "asia-northeast1");
export const functions = getFunctions(firebaseApp);
const analytics = getAnalytics(firebaseApp);
logEvent(analytics, "notification_received");

// //テスト用
if (process.env.NODE_ENV != "production") {
  connectFunctionsEmulator(functions, "localhost", 5001);
}
// Vue.use(VueRouter);

// createApp(App).mount('#app')
const app = createApp(App)
app.use(router)
// app.use(Spinner)
app.mount("#app")

// new Vue({
//   router,
//   // store,
//   render: (h) => h(App),
//   // wait: new VueWait(),
// }).$mount("#app");
